/// <reference types="fhir" />

// Import of actions
import * as UserActions from "../actions/user.actions";
import {
  availableLanguages,
  UserTypes,
  PatientListingColumnType,
  evalConsentType,
  staffType,
  fetchPeriodType
} from "../../models/types";
import { environmentFactory } from "../../environment-variables/environment-variables.module";

const envVars = environmentFactory();

export interface UserState {
  jwt: string;
  uuid: string;
  email: string;
  language: availableLanguages;
  userName: string;
  userType: UserTypes;
  isSuperUser: boolean;
  userInitials: string;
  userFhir: fhir.Practitioner;
  organizationUuid: string;
  definitionsLoaded: boolean;
  displayedColumnsInPatientListing: PatientListingColumnType[];
  evalConsent: evalConsentType;
  evalConsentResponseUuid: string;
  staffType: staffType;
  isDeactivated: boolean;
  deactivationReason: string;
  ffColorBlindMode: boolean; // Not stored on backend
  currentConsultationsMode: fetchPeriodType; // Not stored on backend
  curConsultationsStartDate: string; // Not stored on backend
  curConsultationsEndDate: string; // Not stored on backend
}

export const initialState: UserState = {
  jwt: null,
  uuid: null, // user uuid
  email: null,
  language: envVars.DEFAULT_LANGUAGE,
  userName: null,
  userType: null,
  isSuperUser: false,
  userInitials: null,
  userFhir: null,
  organizationUuid: null,
  definitionsLoaded: false,
  displayedColumnsInPatientListing: null,
  evalConsent: null,
  evalConsentResponseUuid: null,
  staffType: null,
  isDeactivated: false,
  deactivationReason: null,
  ffColorBlindMode: false,
  currentConsultationsMode: "TODAY",
  curConsultationsStartDate: null,
  curConsultationsEndDate: null
};

export function userReducer(state = initialState, action: UserActions.Actions) {
  switch (action.type) {
    case UserActions.LOGOUT: {
      return initialState;
    }
    case UserActions.LOGIN: {
      return { ...state, ...action.payload }; //st{}, state, action.payload);
    }
    case UserActions.SET_JWT: {
      return { ...state, ...action.payload };
    }
    case UserActions.LANGUAGE: {
      return { ...state, ...action.payload };
    }
    case UserActions.UPDATE: {
      return { ...state, ...action.payload };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/user.reducer.ts